var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixedBg),expression:"isFixedBg"}],staticClass:"b-fixed-background",on:{"click":_vm.hideFixedBg}})
}
var staticRenderFns = []

export { render, staticRenderFns }